function updateJKLolDetails(target, variant) {
  const layout = target.closest('.product-layout');
  if (!layout || !variant) return;
  const values = (variant.options || []).join(' ').toLowerCase();
  const garment = /sf000|sweatshirt/.test(values) ? 'sweatshirt' : /g500|t-shirt|t shirt/.test(values) ? 'tee' : '';
  if (!garment) return;
  layout.querySelectorAll('[data-garment-details]').forEach(section => {
    section.hidden = section.dataset.garmentDetails !== garment;
  });
}
document.addEventListener('variant:change', event => updateJKLolDetails(event.target, event.detail.variant));

function updateJKLolGallery(target, variant) {
  const layout = target.closest('.product-layout');
  const gallery = layout && layout.querySelector('[data-product-gallery]');
  if (!gallery || !variant) return;
  const items = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
  if (!items.length) return;
  const groupFromSource = source => {
    const match = String(source || '').match(/ninjapod_media_\d+_(\d+)_(\d+)_/i);
    return match ? match[1] + '_' + match[2] : '';
  };
  const group = groupFromSource(variant.imageSrc);
  let matches = group ? items.filter(item => item.dataset.imageGroup === group) : [];
  if (!matches.length && variant.imageId) matches = items.filter(item => item.dataset.imageId === String(variant.imageId));
  if (!matches.length && variant.id) {
    matches = items.filter(item => {
      try { return JSON.parse(item.dataset.variantIds || '[]').some(id => String(id) === String(variant.id)); }
      catch { return false; }
    });
  }
  if (!matches.length) matches = [items[0]];
  items.forEach(item => {
    const visible = matches.includes(item);
    item.hidden = !visible;
    item.classList.toggle('is-primary', item === matches[0]);
    const image = item.querySelector('img');
    if (image) {
      image.setAttribute('fetchpriority', item === matches[0] ? 'high' : 'auto');
      if (item === matches[0]) image.setAttribute('loading', 'eager');
    }
  });
}
document.addEventListener('variant:change', event => updateJKLolGallery(event.target, event.detail.variant));

class JKLolVariantPicker extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    try {
      this.variants = JSON.parse(this.querySelector('[data-variant-data]').textContent);
      this.selects = Array.from(this.querySelectorAll('[data-option-index]'));
      this.master = this.querySelector('[data-variant-select]');
      this.details = this.closest('.product-details');
      if (!this.variants.length || !this.selects.length || !this.master || !this.details) return;
      this.selects.forEach(select => {
        if (select.dataset.optionKind === 'size') {
          const rank = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL', '4XL', '5XL', '6XL'];
          const options = Array.from(select.options);
          options.sort((a, b) => {
            const ai = rank.indexOf(a.value.toUpperCase());
            const bi = rank.indexOf(b.value.toUpperCase());
            return (ai < 0 ? 100 : ai) - (bi < 0 ? 100 : bi);
          });
          options.forEach(option => select.appendChild(option));
        }
        select.addEventListener('change', () => this.resolve(select));
      });
      this.resolve(null, false);
      this.querySelector('[data-option-fields]').hidden = false;
      this.querySelector('[data-variant-fallback]').hidden = true;
      this.onPopState = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.variants.find(v => String(v.id) === id) || this.variants.find(v => String(v.id) === this.master.value);
        if (variant) {
          this.selects.forEach(select => { select.value = variant.options[Number(select.dataset.optionIndex)]; });
          this.resolve(null, false);
        }
      };
      window.addEventListener('popstate', this.onPopState);
    } catch {
      this.querySelector('[data-option-fields]').hidden = true;
      this.querySelector('[data-variant-fallback]').hidden = false;
    }
  }
  disconnectedCallback() {
    if (this.onPopState) window.removeEventListener('popstate', this.onPopState);
    this.initialized = false;
  }
  resolve(changed, updateUrl = true) {
    let candidates = this.variants;
    this.selects.forEach(select => {
      const index = Number(select.dataset.optionIndex);
      Array.from(select.options).forEach(option => {
        const matches = candidates.filter(variant => variant.options[index] === option.value);
        option.hidden = matches.length === 0;
        option.disabled = !matches.some(variant => variant.available);
        option.textContent = option.dataset.label + (matches.length && option.disabled ? ' — ' + select.dataset.soldLabel : '');
      });
      let selected = Array.from(select.options).find(option => option.value === select.value);
      if (!selected || selected.hidden) {
        const replacement = Array.from(select.options).find(option => !option.hidden && !option.disabled) || Array.from(select.options).find(option => !option.hidden);
        select.value = replacement ? replacement.value : '';
      } else if (changed && select !== changed && selected.disabled) {
        const replacement = Array.from(select.options).find(option => !option.hidden && !option.disabled);
        if (replacement) select.value = replacement.value;
      }
      candidates = candidates.filter(variant => variant.options[index] === select.value);
    });
    const variant = candidates[0];
    const button = this.details.querySelector('[data-add]');
    if (!variant) {
      this.master.value = '';
      button.disabled = true;
      button.textContent = button.dataset.soldLabel;
      return;
    }
    this.master.value = String(variant.id);
    this.details.querySelector('[data-price]').textContent = variant.price;
    button.disabled = !variant.available;
    button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(variant.id));
      history.replaceState({}, '', url);
    }
    this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
  }
}
if (!customElements.get('jklol-variant-picker')) customElements.define('jklol-variant-picker', JKLolVariantPicker);
document.addEventListener('change', event => {
  if (!event.target.matches('[data-variant-select]')) return;
  const select = event.target;
  const option = select.selectedOptions[0];
  const container = select.closest('.product-details');
  const button = container.querySelector('[data-add]');
  container.querySelector('[data-price]').textContent = option.dataset.price;
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
  const url = new URL(location.href);
  url.searchParams.set('variant', select.value);
  history.replaceState({}, '', url);
  let variant = { id: select.value, imageId: option.dataset.imageId, imageSrc: option.dataset.imageSource };
  try {
    const picker = select.closest('jklol-variant-picker');
    variant = JSON.parse(picker.querySelector('[data-variant-data]').textContent).find(item => String(item.id) === select.value) || variant;
  } catch {}
  updateJKLolGallery(container, variant);
  updateJKLolDetails(container, variant);
});
